<div class="tabs-frame">
  @if (routed()) {
    <nav class="tabs" [attr.aria-label]="ariaLabel() || null" (focusin)="onFocusIn($event)">
      @for (tab of tabs(); track tab.id) {
        @if (tab.disabled || !tab.route) {
          <span class="tab tab--disabled" aria-disabled="true">
            @if (tab.icon) {
              <span class="tab__icon" aria-hidden="true" [innerHTML]="tab.icon | safeHtml"></span>
            }
            <span class="tab__label" [attr.data-label]="tab.label">{{ tab.label }}</span>
          </span>
        } @else {
          <a
            class="tab"
            [id]="tabElementId(tab.id)"
            [routerLink]="tab.route"
            routerLinkActive="tab--active"
            [routerLinkActiveOptions]="{ exact: !!tab.exact }"
            ariaCurrentWhenActive="page">
            @if (tab.icon) {
              <span class="tab__icon" aria-hidden="true" [innerHTML]="tab.icon | safeHtml"></span>
            }
            <span class="tab__label" [attr.data-label]="tab.label">{{ tab.label }}</span>
          </a>
        }
      }
    </nav>
  } @else {
    <div class="tabs" role="tablist" [attr.aria-label]="ariaLabel() || null" (focusin)="onFocusIn($event)">
      @for (tab of tabs(); track tab.id; let i = $index) {
        <button
          #tabButton
          type="button"
          role="tab"
          class="tab"
          [id]="tabElementId(tab.id)"
          [class.tab--active]="tab.id === active()"
          [class.tab--disabled]="tab.disabled"
          [attr.aria-selected]="tab.id === active()"
          [attr.aria-controls]="tab.controls || null"
          [attr.aria-disabled]="tab.disabled ? 'true' : null"
          [attr.tabindex]="tab.id === tabStopId() ? 0 : -1"
          (click)="select(tab)"
          (keydown)="onKeydown($event, i)">
          @if (tab.icon) {
            <span class="tab__icon" aria-hidden="true" [innerHTML]="tab.icon | safeHtml"></span>
          }
          <span class="tab__label" [attr.data-label]="tab.label">{{ tab.label }}</span>
        </button>
      }
    </div>
  }
</div>
